import { List } from 'braid-design-system';
import type { ComponentProps } from 'react';

import { useOrderedListContext } from './OrderedListContext.tsx';
import { SIZE_TO_SPACE, type Size } from './size.ts';

type Props = Pick<ComponentProps<typeof List>, 'children'> & {
  size?: Size;
  start?: number;
};

export const MdxOrderedList = ({
  children,
  size = 'standard',
  start,
}: Props) => {
  const { NextOrderedListProvider, type } = useOrderedListContext();

  const space = SIZE_TO_SPACE[size];

  return (
    <NextOrderedListProvider>
      <List size={size} space={space} start={start} type={type}>
        {children}
      </List>
    </NextOrderedListProvider>
  );
};
